"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var AppSettings_1 = tslib_1.__importDefault(require("../../apiServices/auth/AppSettings"));
var Assets_1 = require("../../api/Assets");
var ExceptionHandler_1 = require("../../models/common/base/ExceptionHandler");
var Permissions_1 = require("../../apiServices/rbac/permissions/Permissions");
var PermissionsGroup_1 = require("../../apiServices/rbac/group/PermissionsGroup");
var Objects_1 = require("../../api/Objects");
var SceAssets = /** @class */ (function () {
    function SceAssets() {
        this._assetsApi = new Assets_1.Assets();
        this._objects = new Objects_1.Objects();
    }
    SceAssets.prototype.getSystems = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var assets, apiResponse, result, error_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        AppSettings_1.default.verifyUrlInitializationState();
                        Permissions_1.rbacPermissions.verifyObjectReadPermission();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        assets = new Assets_1.Assets();
                        return [4 /*yield*/, assets.GetSystems()];
                    case 2:
                        apiResponse = _a.sent();
                        result = {
                            status: apiResponse.status,
                            details: apiResponse.data
                        };
                        return [2 /*return*/, result];
                    case 3:
                        error_1 = _a.sent();
                        throw new Error(this.handleAssetsError(error_1));
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    SceAssets.prototype.systemStructureChildObjectsDetails = function (objectId, modelId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var assets, apiResponse, result, error_2;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        AppSettings_1.default.verifyUrlInitializationState();
                        Permissions_1.rbacPermissions.verifyObjectReadPermission();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        assets = new Assets_1.Assets();
                        return [4 /*yield*/, assets.systemStructureChildObjectsDetails(objectId, modelId)];
                    case 2:
                        apiResponse = _a.sent();
                        result = {
                            status: apiResponse.status,
                            details: apiResponse.data
                        };
                        return [2 /*return*/, result];
                    case 3:
                        error_2 = _a.sent();
                        throw new Error(this.handleAssetsError(error_2));
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    SceAssets.prototype.systemStructureChildObjects = function (objectId, modelId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var assets, apiResponse, result, error_3;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        AppSettings_1.default.verifyUrlInitializationState();
                        Permissions_1.rbacPermissions.verifyObjectReadPermission();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        assets = new Assets_1.Assets();
                        return [4 /*yield*/, assets.systemStructureChildObjects(objectId, modelId)];
                    case 2:
                        apiResponse = _a.sent();
                        result = {
                            status: apiResponse.status,
                            details: apiResponse.data
                        };
                        return [2 /*return*/, result];
                    case 3:
                        error_3 = _a.sent();
                        throw new Error(this.handleAssetsError(error_3));
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    SceAssets.prototype.getEdges = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var assets, apiResponse, result, error_4;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        AppSettings_1.default.verifyUrlInitializationState();
                        Permissions_1.rbacPermissions.verifyObjectReadPermission();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        assets = new Assets_1.Assets();
                        return [4 /*yield*/, assets.GetEdges()];
                    case 2:
                        apiResponse = _a.sent();
                        result = {
                            status: apiResponse.status,
                            details: apiResponse.data
                        };
                        return [2 /*return*/, result];
                    case 3:
                        error_4 = _a.sent();
                        throw new Error(this.handleAssetsError(error_4));
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    SceAssets.prototype.getDevicesConnectivityType = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var assets, apiResponse, result, error_5;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        AppSettings_1.default.verifyUrlInitializationState();
                        Permissions_1.rbacPermissions.verifyObjectReadPermission();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        assets = new Assets_1.Assets();
                        return [4 /*yield*/, assets.GetDevicesConnectivityType()];
                    case 2:
                        apiResponse = _a.sent();
                        result = {
                            status: apiResponse.status,
                            details: apiResponse.data
                        };
                        return [2 /*return*/, result];
                    case 3:
                        error_5 = _a.sent();
                        throw new Error(this.handleAssetsError(error_5));
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    SceAssets.prototype.systemStructureObjectsDetails = function (systemId, modelId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var assets, apiResponse, result, error_6;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        AppSettings_1.default.verifyUrlInitializationState();
                        Permissions_1.rbacPermissions.verifyObjectReadPermission();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        assets = new Assets_1.Assets();
                        return [4 /*yield*/, assets.systemStructureObjectsDetails(systemId, modelId)];
                    case 2:
                        apiResponse = _a.sent();
                        result = {
                            status: apiResponse.status,
                            details: apiResponse.data
                        };
                        return [2 /*return*/, result];
                    case 3:
                        error_6 = _a.sent();
                        throw new Error(this.handleAssetsError(error_6));
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    SceAssets.prototype.systemStructureObjects = function (systemId, modelId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var assets, apiResponse, result, error_7;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        AppSettings_1.default.verifyUrlInitializationState();
                        Permissions_1.rbacPermissions.verifyObjectReadPermission();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        assets = new Assets_1.Assets();
                        return [4 /*yield*/, assets.systemStructureObjects(systemId, modelId)];
                    case 2:
                        apiResponse = _a.sent();
                        result = {
                            status: apiResponse.status,
                            details: apiResponse.data
                        };
                        return [2 /*return*/, result];
                    case 3:
                        error_7 = _a.sent();
                        throw new Error(this.handleAssetsError(error_7));
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    SceAssets.prototype.getObjectByEdge = function (objectId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var assets, apiResponse, result, error_8;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        AppSettings_1.default.verifyUrlInitializationState();
                        Permissions_1.rbacPermissions.verifyObjectReadPermission();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        assets = new Assets_1.Assets();
                        return [4 /*yield*/, assets.GetObjectByEdge(objectId)];
                    case 2:
                        apiResponse = _a.sent();
                        result = {
                            status: apiResponse.status,
                            details: apiResponse.data
                        };
                        return [2 /*return*/, result];
                    case 3:
                        error_8 = _a.sent();
                        throw new Error(this.handleAssetsError(error_8));
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    SceAssets.prototype.getObjectByEdgeWithPaging = function (objectId, count, pageNumber, pageSize) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var assets, apiResponse, result, error_9;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        AppSettings_1.default.verifyUrlInitializationState();
                        Permissions_1.rbacPermissions.verifyObjectReadPermission();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        assets = new Assets_1.Assets();
                        return [4 /*yield*/, assets.getObjectByEdgePaging(objectId, count, pageNumber, pageSize)];
                    case 2:
                        apiResponse = _a.sent();
                        result = {
                            status: apiResponse.status,
                            details: apiResponse.data
                        };
                        return [2 /*return*/, result];
                    case 3:
                        error_9 = _a.sent();
                        throw new Error(this.handleAssetsError(error_9));
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    SceAssets.prototype.getStructures = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var assets, apiResponse, result, error_10;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        AppSettings_1.default.verifyUrlInitializationState();
                        Permissions_1.rbacPermissions.verifyObjectReadPermission();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        assets = new Assets_1.Assets();
                        return [4 /*yield*/, assets.GetStructures()];
                    case 2:
                        apiResponse = _a.sent();
                        result = {
                            status: apiResponse.status,
                            details: apiResponse.data
                        };
                        return [2 /*return*/, result];
                    case 3:
                        error_10 = _a.sent();
                        throw new Error(this.handleAssetsError(error_10));
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    SceAssets.prototype.queryStructureObjectsPaging = function (modelId, query, all, amInfo, count, pageNumber, pageSize) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var assets, apiResponse, result, error_11;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        AppSettings_1.default.verifyUrlInitializationState();
                        PermissionsGroup_1.PermissionsGroup.verifyObjectReadFileDownload();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        assets = new Assets_1.Assets();
                        return [4 /*yield*/, assets.QueryStructureObjectsPaging(modelId, query, all, amInfo, count, pageNumber, pageSize)];
                    case 2:
                        apiResponse = _a.sent();
                        result = {
                            status: apiResponse.status,
                            details: apiResponse.data
                        };
                        return [2 /*return*/, result];
                    case 3:
                        error_11 = _a.sent();
                        throw new Error(this.handleAssetsError(error_11));
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    SceAssets.prototype.getVariables = function (objectId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var assets, apiResponse, result, error_12;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        AppSettings_1.default.verifyUrlInitializationState();
                        Permissions_1.rbacPermissions.verifyObjectReadPermission();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        assets = new Assets_1.Assets();
                        return [4 /*yield*/, assets.GetVariables(objectId)];
                    case 2:
                        apiResponse = _a.sent();
                        result = {
                            status: apiResponse.status,
                            details: apiResponse.data
                        };
                        return [2 /*return*/, result];
                    case 3:
                        error_12 = _a.sent();
                        throw new Error(this.handleAssetsError(error_12));
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    SceAssets.prototype.querySystemStructureObjects = function (modelId, query, all, amInfo) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var assets, apiResponse, result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        AppSettings_1.default.verifyUrlInitializationState();
                        Permissions_1.rbacPermissions.verifyObjectReadPermission();
                        assets = new Assets_1.Assets();
                        return [4 /*yield*/, assets.QuerySystemStructureObjects(modelId, query, all, amInfo)];
                    case 1:
                        apiResponse = _a.sent();
                        result = {
                            status: apiResponse.status,
                            details: apiResponse.data
                        };
                        return [2 /*return*/, result];
                }
            });
        });
    };
    SceAssets.prototype.getSystemStructureModels = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var response, result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        AppSettings_1.default.verifyUrlInitializationState();
                        PermissionsGroup_1.PermissionsGroup.verifyObjectReadTypeDefReadFileDownload();
                        return [4 /*yield*/, this._assetsApi.getSystemStructureModels()];
                    case 1:
                        response = _a.sent();
                        result = {
                            details: response.data,
                            status: response.status
                        };
                        return [2 /*return*/, result];
                }
            });
        });
    };
    SceAssets.prototype.getConnectDetailsFromIdentityModels = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var response, result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        AppSettings_1.default.verifyUrlInitializationState();
                        PermissionsGroup_1.PermissionsGroup.verifyObjectReadTypeDefRead();
                        return [4 /*yield*/, this._assetsApi.getConnectDetailsFromIdentityModels()];
                    case 1:
                        response = _a.sent();
                        result = {
                            details: response.data,
                            status: response.status
                        };
                        return [2 /*return*/, result];
                }
            });
        });
    };
    SceAssets.prototype.getSystemsBasedOnConnectModel = function (modelId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var response, result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        AppSettings_1.default.verifyUrlInitializationState();
                        PermissionsGroup_1.PermissionsGroup.verifyObjectReadTypeDefRead();
                        return [4 /*yield*/, this._assetsApi.getSystemsBasedOnConnectModel(modelId)];
                    case 1:
                        response = _a.sent();
                        result = {
                            details: response.data,
                            status: response.status
                        };
                        return [2 /*return*/, result];
                }
            });
        });
    };
    SceAssets.prototype.getChildObjects = function (query, groupBy, nameLookupModel, groupingIdentifier, all, aminfo, pageNumber, pageSize) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var response, result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        AppSettings_1.default.verifyUrlInitializationState();
                        PermissionsGroup_1.PermissionsGroup.verifyObjectReadTypeDefReadFileDownload();
                        return [4 /*yield*/, this._assetsApi.getChildObjects(query, groupBy, nameLookupModel, groupingIdentifier, all, aminfo, 0, pageNumber, pageSize)];
                    case 1:
                        response = _a.sent();
                        result = {
                            details: response.data,
                            status: response.status
                        };
                        return [2 /*return*/, result];
                }
            });
        });
    };
    SceAssets.prototype.getChildObjectsST = function (query, groupBy, nameLookupModel, groupingIdentifier, all, aminfo, pageNumber, pageSize) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var response, result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        AppSettings_1.default.verifyUrlInitializationState();
                        PermissionsGroup_1.PermissionsGroup.verifyObjectReadTypeDefReadFileDownload();
                        return [4 /*yield*/, this._assetsApi.getChildObjectsST(query, groupBy, nameLookupModel, groupingIdentifier, all, aminfo, 0, pageNumber, pageSize)];
                    case 1:
                        response = _a.sent();
                        result = {
                            details: response.data,
                            status: response.status
                        };
                        return [2 /*return*/, result];
                }
            });
        });
    };
    SceAssets.prototype.filterObjects = function (query, groupBy, nameLookupModel, groupingIdentifier, all, amInfo, filterOptions, pageNumber, pageSize) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var response, result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        AppSettings_1.default.verifyUrlInitializationState();
                        PermissionsGroup_1.PermissionsGroup.verifyObjectReadTypeDefReadFileDownload();
                        return [4 /*yield*/, this._assetsApi.filterObjects(query, groupBy, nameLookupModel, groupingIdentifier, all, amInfo, filterOptions, 0, pageNumber, pageSize)];
                    case 1:
                        response = _a.sent();
                        result = {
                            details: response.data,
                            status: response.status
                        };
                        return [2 /*return*/, result];
                }
            });
        });
    };
    SceAssets.prototype.filterSystemStructureObjects = function (model, pageNumber, pageSize, query, all, amInfo, filterOptions) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var response, result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        AppSettings_1.default.verifyUrlInitializationState();
                        PermissionsGroup_1.PermissionsGroup.verifyObjectReadFileDownload();
                        return [4 /*yield*/, this._assetsApi.filterSystemStructureObjects(model, 0, pageNumber, pageSize, query, all, amInfo, filterOptions)];
                    case 1:
                        response = _a.sent();
                        result = {
                            details: response.data,
                            status: response.status
                        };
                        return [2 /*return*/, result];
                }
            });
        });
    };
    SceAssets.prototype.filterEdgeObjects = function (edgeId, pageNumber, pageSize, filterOptions) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var response, result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        AppSettings_1.default.verifyUrlInitializationState();
                        PermissionsGroup_1.PermissionsGroup.verifyObjectReadFileDownload();
                        return [4 /*yield*/, this._assetsApi.filterEdgeObjects(edgeId, 0, pageNumber, pageSize, filterOptions)];
                    case 1:
                        response = _a.sent();
                        result = {
                            details: response.data,
                            status: response.status
                        };
                        return [2 /*return*/, result];
                }
            });
        });
    };
    SceAssets.prototype.getAssetTypes = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var response, result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        AppSettings_1.default.verifyUrlInitializationState();
                        Permissions_1.rbacPermissions.verifyObjectReadPermission();
                        return [4 /*yield*/, this._assetsApi.getAssetTypes()];
                    case 1:
                        response = _a.sent();
                        result = {
                            details: response.data,
                            status: response.status
                        };
                        return [2 /*return*/, result];
                }
            });
        });
    };
    SceAssets.prototype.getAssetModelTypes = function (objectId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var response, result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        AppSettings_1.default.verifyUrlInitializationState();
                        Permissions_1.rbacPermissions.verifyObjectReadPermission();
                        return [4 /*yield*/, this._assetsApi.getAssetModelTypes(objectId)];
                    case 1:
                        response = _a.sent();
                        result = {
                            details: response.data,
                            status: response.status
                        };
                        return [2 /*return*/, result];
                }
            });
        });
    };
    SceAssets.prototype.deleteObject = function (objectId, modelId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var response, result, error_13;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        AppSettings_1.default.verifyUrlInitializationState();
                        Permissions_1.rbacPermissions.verifyObjectDeletePermission();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        return [4 /*yield*/, this._objects.deleteOwner(objectId, modelId)];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, this._objects.deleteObject(objectId, modelId)];
                    case 3:
                        response = _a.sent();
                        result = {
                            details: response.data,
                            status: response.status
                        };
                        return [2 /*return*/, result];
                    case 4:
                        error_13 = _a.sent();
                        throw new Error(this.handleAssetsError(error_13));
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    SceAssets.prototype.createStrucutreModel = function (name, modelId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var response, result, error_14;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        AppSettings_1.default.verifyUrlInitializationState();
                        PermissionsGroup_1.PermissionsGroup.verifyTypeDefReadCreate();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this._assetsApi.createStrucutreModel(name, modelId)];
                    case 2:
                        response = _a.sent();
                        result = {
                            status: response.status,
                            details: response.data,
                        };
                        return [2 /*return*/, result];
                    case 3:
                        error_14 = _a.sent();
                        throw new Error(this.handleAssetsError(error_14));
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    SceAssets.prototype.editStrucutreModel = function (name, modelId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var response, result, error_15;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        AppSettings_1.default.verifyUrlInitializationState();
                        PermissionsGroup_1.PermissionsGroup.verifyTypeDefReadWrite();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this._assetsApi.editStrucutreModel(name, modelId)];
                    case 2:
                        response = _a.sent();
                        result = {
                            status: response.status,
                            details: response.data,
                        };
                        return [2 /*return*/, result];
                    case 3:
                        error_15 = _a.sent();
                        throw new Error(this.handleAssetsError(error_15));
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    SceAssets.prototype.deleteStrucutreModel = function (modelId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var response, result, error_16;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        AppSettings_1.default.verifyUrlInitializationState();
                        PermissionsGroup_1.PermissionsGroup.verifyTypeDefReadDelete();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this._assetsApi.deleteStrucutreModel(modelId)];
                    case 2:
                        response = _a.sent();
                        result = {
                            status: response.status,
                            details: response.data,
                        };
                        return [2 /*return*/, result];
                    case 3:
                        error_16 = _a.sent();
                        throw new Error(this.handleAssetsError(error_16));
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    SceAssets.prototype.cloneStrucutreModel = function (clonedStrucutreName, clonedStrucutreModelId, originSourceId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var response, result, error_17;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        AppSettings_1.default.verifyUrlInitializationState();
                        PermissionsGroup_1.PermissionsGroup.verifyTypeDefReadCreate();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this._assetsApi.cloneStrucutreModel(clonedStrucutreName, clonedStrucutreModelId, originSourceId)];
                    case 2:
                        response = _a.sent();
                        result = {
                            status: response.status,
                            details: response.data,
                        };
                        return [2 /*return*/, result];
                    case 3:
                        error_17 = _a.sent();
                        throw new Error(this.handleAssetsError(error_17));
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    SceAssets.prototype.getSystemStructureModelNamesAndIdsForTenantExt = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var response, result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        AppSettings_1.default.verifyUrlInitializationState();
                        PermissionsGroup_1.PermissionsGroup.verifyObjectReadTypeDefRead();
                        return [4 /*yield*/, this._assetsApi.getSystemStructureModelNamesAndIdsForTenantExt()];
                    case 1:
                        response = _a.sent();
                        result = {
                            details: response.data,
                            status: response.status
                        };
                        return [2 /*return*/, result];
                }
            });
        });
    };
    SceAssets.prototype.getSystemStructureModelNamesAndIdsForTenantExt2 = function (systemId, groupingIdentifier) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var response, result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        AppSettings_1.default.verifyUrlInitializationState();
                        PermissionsGroup_1.PermissionsGroup.verifyObjectReadTypeDefRead();
                        return [4 /*yield*/, this._assetsApi.getSystemStructureModelNamesAndIdsForTenantExt2(systemId, groupingIdentifier)];
                    case 1:
                        response = _a.sent();
                        result = {
                            details: response.data,
                            status: response.status
                        };
                        return [2 /*return*/, result];
                }
            });
        });
    };
    SceAssets.prototype.getSystemStructureModelsForSpecificTenant = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var response, result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        AppSettings_1.default.verifyUrlInitializationState();
                        PermissionsGroup_1.PermissionsGroup.verifyObjectReadTypeDefRead();
                        return [4 /*yield*/, this._assetsApi.getSystemStructureModelsForSpecificTenant()];
                    case 1:
                        response = _a.sent();
                        result = {
                            details: response.data,
                            status: response.status
                        };
                        return [2 /*return*/, result];
                }
            });
        });
    };
    SceAssets.prototype.addStrucutreNode = function (parentObjectId, objectId, structureModelId, name, originStructureModelId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var response, result, error_18;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        AppSettings_1.default.verifyUrlInitializationState();
                        PermissionsGroup_1.PermissionsGroup.verifyTypeDefReadCreate();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this._assetsApi.addStrucutreNode(parentObjectId, objectId, structureModelId, name, originStructureModelId)];
                    case 2:
                        response = _a.sent();
                        result = {
                            status: response.status,
                            details: response.data,
                        };
                        return [2 /*return*/, result];
                    case 3:
                        error_18 = _a.sent();
                        throw new Error(this.handleAssetsError(error_18));
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    SceAssets.prototype.editStrucutreNodeName = function (newName, objectId, structureModelId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var response, result, error_19;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        AppSettings_1.default.verifyUrlInitializationState();
                        PermissionsGroup_1.PermissionsGroup.verifyTypeDefReadWrite();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this._assetsApi.editStrucutreNodeName(newName, objectId, structureModelId)];
                    case 2:
                        response = _a.sent();
                        result = {
                            status: response.status,
                            details: response.data,
                        };
                        return [2 /*return*/, result];
                    case 3:
                        error_19 = _a.sent();
                        throw new Error(this.handleAssetsError(error_19));
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    SceAssets.prototype.deleteStrucutreNode = function (modelId, objectId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var response, result, error_20;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        AppSettings_1.default.verifyUrlInitializationState();
                        PermissionsGroup_1.PermissionsGroup.verifyTypeDefReadDelete();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this._assetsApi.deleteStrucutreNode(modelId, objectId)];
                    case 2:
                        response = _a.sent();
                        result = {
                            status: response.status,
                            details: response.data,
                        };
                        return [2 /*return*/, result];
                    case 3:
                        error_20 = _a.sent();
                        throw new Error(this.handleAssetsError(error_20));
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    SceAssets.prototype.handleAssetsError = function (error) {
        var exceptionHandler = new ExceptionHandler_1.ExceptionHandler();
        return JSON.stringify(exceptionHandler.buildExceptionFromError(error));
    };
    return SceAssets;
}());
exports.SceAssets = SceAssets;
//# sourceMappingURL=SceAssets.js.map